import { createSelector, createSlice } from "@reduxjs/toolkit";
const initialState = {
    advisoryMap: {},
    selectedAdvisoryView: null,
    saaMap: {},
    sectorSaaDisplayMap: {},
    selectedViewOption: null,
    uiSubscribed: false,
    activeInput: null,
    ownedFavIds: [],
};
const defaultSaaDisplay = { cold: "OFF", hot: "OFF" };
export const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
        updateAdvisories(state, action) {
            for (const a of action.payload) {
                state.advisoryMap[a.name] = a;
            }
        },
        removeAdvisories(state, action) {
            for (const id of action.payload) {
                delete state.advisoryMap[id];
            }
        },
        setSelectedAdvisory(state, action) {
            state.selectedAdvisoryView = action.payload;
        },
        setOwnedFavIds(state, action) {
            state.ownedFavIds = action.payload;
        },
        setSaaMap(state, action) {
            state.saaMap = action.payload;
        },
        setSaa(state, action) {
            state.saaMap[action.payload.saaId] = action.payload.saa;
        },
        setSectorSaaDisplayMap(state, action) {
            state.sectorSaaDisplayMap = action.payload;
        },
        setSectorSaaDisplay(state, action) {
            state.sectorSaaDisplayMap[action.payload.saaId] = action.payload.display;
        },
        setSaaActivations(state, action) {
            state.saaMap[action.payload.saaId].activations = action.payload.activations;
            state.saaMap[action.payload.saaId].forcedOff = action.payload.forcedOff;
        },
        setUiSubscribed(state, action) {
            state.uiSubscribed = action.payload;
        },
        setSelectedViewOption(state, action) {
            state.selectedViewOption = action.payload;
        },
        closeSpecificViewOption(state, action) {
            if (state.selectedViewOption === action.payload) {
                state.selectedViewOption = null;
            }
        },
        toggleSelectedViewOption(state, action) {
            state.selectedViewOption = state.selectedViewOption === action.payload ? null : action.payload;
        },
        setActiveInput(state, action) {
            state.activeInput = action.payload;
        },
    },
    selectors: {
        advisoryMapSelector: (state) => state.advisoryMap,
        selectedAdvViewSelector: (state) => state.selectedAdvisoryView,
        selectedAdvisorySelector: (state) => state.selectedAdvisoryView?.name ? state.advisoryMap[state.selectedAdvisoryView.name] : null,
        saaMapSelector: (state) => state.saaMap,
        saaListSelector: createSelector((state) => state.saaMap, (saaMap) => Object.values(saaMap)),
        saaSelector: (state, saaId) => state.saaMap[saaId],
        sectorSaaDisplayMapSelector: (state) => state.sectorSaaDisplayMap,
        sectorSaaDisplaySelector: createSelector([(state) => state.sectorSaaDisplayMap, (_, saaId) => saaId], (saaDisplayMap, saaId) => saaDisplayMap[saaId] ?? defaultSaaDisplay),
        selectedViewOptionSelector: (state) => state.selectedViewOption,
        uiSubscribedSelector: (state) => state.uiSubscribed,
        activeInputSelector: (state) => state.activeInput,
        ownedFavIdsSelector: (state) => state.ownedFavIds,
    },
});
export const commonReducer = commonSlice.reducer;
export const { updateAdvisories, removeAdvisories, setSelectedAdvisory, setSaaMap, setSaa, setSectorSaaDisplayMap, setSectorSaaDisplay, setSaaActivations, setSelectedViewOption, closeSpecificViewOption, toggleSelectedViewOption, setUiSubscribed, setActiveInput, setOwnedFavIds, } = commonSlice.actions;
export const { advisoryMapSelector, selectedAdvViewSelector, selectedAdvisorySelector, saaMapSelector, saaListSelector, saaSelector, sectorSaaDisplayMapSelector, sectorSaaDisplaySelector, selectedViewOptionSelector, uiSubscribedSelector, activeInputSelector, ownedFavIdsSelector, } = commonSlice.getSelectors((state) => state.common);
//# sourceMappingURL=commonSlice.js.map